<template>
<main class="sa-content sa-aptlistbox">
    <div class="sa-card-large">
        <img v-if="loader" src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
        <template v-else>
            <h5 class="sa-card-tit sa-h-xs">Schedule configuration</h5>
            <div class="sa-mob-header sa-h-sm-up sa-header1">
                <h5 class="sa-card-tit">Schedule</h5>
                <button class="sa-btn-back" @click="$router.go(-1)">
                    <i class="icon-left-arrow"></i>
                </button>
            </div>
            <div class=" sa-mob-cont">
                <div class="sa-alert sa-a-warning sa-custom-alert">
                    <i class="icon-info"></i> {{scheduleList && scheduleList.last_app_date}}
                     <!-- <i class="icon-cancel sa-a-close"></i> -->
                </div>
                <div class="sa-form-group sa-d-flex" v-if="multi_slot==true">
                    <span><input type="radio" id=15 name="radio" value=15 v-model="slService" @change="getScheduleData()" />
                        <label for=15>15 Min</label></span>
                    <span class="sa-ml20"><input type="radio" id=20 name="radio" value=20 v-model="slService" @change="getScheduleData()" />
                        <label for=20>20 Min</label></span>
                </div>
                <template v-if="eflag">
                    <schedule-week :scheduledata="scheduleList" @change="scheduleDays = $event" :slService='slService' :multi_slot='multi_slot' />
                    <!--  <schedule-time v-if="scheduleDays == '0'" /> -->
                </template>
                <template v-else>
                    <no-data-found class="sa-mt25" />
                </template>
            </div>
        </template>
    </div>
</main>
</template>

<script>
import {
    pro_url
} from '../../../config/endpoints'
import ScheduleWeekVue from '../../components/schedule/ScheduleWeek.vue';
import NoDataFoundVue from '../../components/common/NoDataFound.vue';
import async from "async";
export default {
    components: {
        'schedule-week': ScheduleWeekVue,
        'no-data-found': NoDataFoundVue
    },
    data() {
        return {
            duration: '',
            scheduleDays: '0',
            loader: false,
            scheduleList: null,
            eflag: true,
            slService: 15,
            multi_slot: false
        };
    },
    methods: {
        weekDaysClick(value) {},
        getMultiSlot(cb) {
            let _self = this;
            _self.loading = true;
            _self.$store
                .dispatch("httpGet", {
                    uri: `${pro_url}/checkingMultiSlotConfig`,
                    body: {}
                })
                .then(response => {
                    if (response.status === 1000) {
                        _self.multi_slot = response.multiSlot
                    }
                    return cb()
                })
                .catch(e => {
                    // console.log(e);
                    return cb()
                });

        },
        getScheduleData() {
            let _self = this;
            _self.loader = true;
            if (_self.slService) {
                this.duration = _self.slService
            }
            _self.$store.dispatch('httpPost', {
                uri: `${pro_url}/v1/getSchedule`,
                body: {
                    duration: _self.multi_slot ? this.duration : undefined
                },

            }).then(response => {
                if (response && response.status === 1000) {
                    if (!_.isEmpty(response.data)) {
                        // _self.apList = response.data.data
                        //  _self.eflag = true
                        _self.scheduleList = response.data
                    } else {
                        _self.scheduleList = [];
                    }
                    _self.loader = false
                } else if (response && response.status == '2001') {
                    _self.$store.dispatch('SET_ALERTMESSAGE', {
                        'msg': 'Session Expired. Please login again',
                        class: 'sa-a-danger'
                    })
                    _self.loader = false;
                    _self.$localStorage.remove("token")
                    _self.$localStorage.remove("userdata")
                    _self.$router.push({
                        path: '/'
                    })
                } else {
                    // _self.$router.push({path:'/404-error'})
                    _self.eflag = false;
                    _self.loader = false;
                }
            }).catch(e => {
                // _self.$router.push({path:'/404-error'})
                _self.eflag = false;
                _self.loader = false;
            });
        },
        getScheduleDataOnMount(cb) {
            let _self = this;
            _self.loader = true;
            if (_self.slService) {
                this.duration = _self.slService
            }
            console.log('_self.multi_slot', _self.multi_slot)
            _self.$store.dispatch('httpPost', {
                uri: `${pro_url}/v1/getSchedule`,
                body: {
                    duration: _self.multi_slot ? this.duration : undefined
                },

            }).then(response => {
                if (response && response.status === 1000) {
                    if (!_.isEmpty(response.data)) {
                        // _self.apList = response.data.data
                        //  _self.eflag = true
                        _self.scheduleList = response.data
                    } else {
                        _self.scheduleList = [];
                    }
                    _self.loader = false
                } else if (response && response.status == '2001') {
                    _self.$store.dispatch('SET_ALERTMESSAGE', {
                        'msg': 'Session Expired. Please login again',
                        class: 'sa-a-danger'
                    })
                    _self.loader = false;
                    _self.$localStorage.remove("token")
                    _self.$localStorage.remove("userdata")
                    _self.$router.push({
                        path: '/'
                    })
                } else {
                    // _self.$router.push({path:'/404-error'})
                    _self.eflag = false;
                    _self.loader = false;
                }
                return cb()
            }).catch(e => {
                // _self.$router.push({path:'/404-error'})
                _self.eflag = false;
                _self.loader = false;
                return cb()
            });
        }
    },
    mounted: function () {
        let _self = this
        async.series([
            _self.getMultiSlot.bind(),
            _self.getScheduleDataOnMount.bind()
        ], function () {
            _self.loading = false
        })
    }
}
</script>
